import { Component, Inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UserModel } from "../../api/models/user-model";
import { UserManagementService } from "../../shared/core-jpats/services/user-management.service";

@Component({
    selector: 'app-unauthorized',
    templateUrl: 'unauthorized.component.html'
})
export class UnauthorizedComponent implements OnInit {
  
  user: UserModel = {};
  
  constructor(
    private router:Router,
    private userManagementService: UserManagementService,
    @Inject('INFORMATION') public information: string,
    @Inject('HELP_LINK') public helpLink: string,
    @Inject('HELP_EMAIL') public helpEmail: string,
    @Inject('HELP_NUMBER') public helpNumber: string) {
    this.userManagementService.getCurrentUser().subscribe((user) => {
      this.user = user;
    })
  }

  ngOnInit() {
  }

  onOKClick() {
    this.userManagementService.updateUserInfo(this.user).subscribe();
    this.router.navigateByUrl('/');
  }
}
